import * as THREE from "three";
import SolidGeometry from "./solid-geometry";

// Anel no plano xy extrudado em z: diâmetro externo largura x altura e furo com metade disso
export const RING_INNER_RATIO = 0.5;

export default class RingGeometry extends SolidGeometry {
  constructor(color, { width, height, depth }, positions) {
    const shape = new THREE.Shape();
    shape.absarc(0, 0, 0.5, 0, Math.PI * 2, false);
    const hole = new THREE.Path();
    hole.absarc(0, 0, 0.5 * RING_INNER_RATIO, 0, Math.PI * 2, true);
    shape.holes.push(hole);

    const geometry = new THREE.ExtrudeGeometry(shape, {
      depth: 1,
      bevelEnabled: false,
      curveSegments: 64
    });
    geometry.translate(0, 0, -0.5);
    geometry.scale(width, height, depth);
    super("ring", color, geometry, positions);
  }
}
